module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "bottom",
    attrs: {
      "id": "blood-glucose-targets"
    }
  }, [_c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('mu-icon', {
    staticClass: "card-left-icon",
    staticStyle: {
      "width": "16px"
    },
    attrs: {
      "size": 20,
      "value": "settings_cog"
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.isOpenInput ? _vm.$t('message.closeText') : 'Configure range'),
      expression: "isOpenInput ? $t('message.closeText') : 'Configure range'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "icon": 'add_circle'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": 'remove_circle_outline'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('div', [_c('vue-slider', _vm._b({
    model: {
      value: (_vm.sliderSettings.value),
      callback: function($$v) {
        _vm.$set(_vm.sliderSettings, "value", $$v)
      },
      expression: "sliderSettings.value"
    }
  }, 'vue-slider', _vm.sliderSettings, false))], 1)]), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aa47fc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Targets/BloodGlucose.vue
// module id = 3619
// module chunks = 1